import { render, staticRenderFns } from "./BaseTableHeaderItem.vue?vue&type=template&id=2034ebc0&scoped=true&lang=pug&"
import script from "./BaseTableHeaderItem.vue?vue&type=script&lang=js&"
export * from "./BaseTableHeaderItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableHeaderItem.vue?vue&type=style&index=0&id=2034ebc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2034ebc0",
  null
  
)

export default component.exports